  /* Hide Recharge widget immediately & Style Cart Count/Modal */
  (function() {
    console.log('[NC] Initializing styles...'); // Keep this one
    const styleTag = document.createElement('style');
    styleTag.textContent = `
      .shopify-block.recharge-subscription-widget { display: none !important; }
  `;
    if (document.head) {
        document.head.appendChild(styleTag);
        // console.log('[NC] Style tag appended to head.'); 
    } else {
        document.addEventListener('DOMContentLoaded', () => { // Fallback
            if(document.head) document.head.appendChild(styleTag);
            else console.error('[NC] Failed to find document.head to append styles.');
        });
    }

    // Add cart count indicators immediately if needed for flicker prevention
    document.addEventListener('DOMContentLoaded', addCartCountIndicators);
  })();

  /**
   * Add cart count indicators to cart icons
   */
  function addCartCountIndicators() {
    const headerCartIndicator = document.querySelector('.site-header__cart-indicator');
    if (headerCartIndicator && !headerCartIndicator.querySelector('.site-header__cart-count')) {
      const countSpan = document.createElement('span');
      countSpan.className = 'site-header__cart-count';
      countSpan.textContent = '0';
      headerCartIndicator.appendChild(countSpan);
    }
    const drawerCartIndicator = document.querySelector('#cart-drawer .site-header__cart-indicator');
    if (drawerCartIndicator && !drawerCartIndicator.querySelector('.site-header__cart-count')) {
      const countSpan = document.createElement('span');
      countSpan.className = 'site-header__cart-count';
      countSpan.textContent = '0';
      drawerCartIndicator.appendChild(countSpan);
    }
    // Get initial cart count
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => updateCartCountDisplay(cart.item_count))
      .catch(error => console.error('[NC] Error fetching initial cart count:', error));
  }

  /**
   * Update cart count display
   * @param {number} count - The number of items in the cart.
   */
  function updateCartCountDisplay(count) {
    const countElements = document.querySelectorAll('.site-header__cart-count');
    countElements.forEach(element => {
      element.textContent = count;
      element.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  let modalReturnFocusEl = null;

  function handleModalKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeCancellationModal();
      return;
    }
    if (event.key !== 'Tab') return;
    const modal = document.getElementById('nc-cancellation-modal');
    if (!modal) return;
    const focusables = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusables.length === 0) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openCancellationModal(triggerEl) {
    const modal = document.getElementById('nc-cancellation-modal');
    const overlay = document.getElementById('nc-modal-overlay');
    if (!modal || !overlay) {
      console.error('[NC] Modal elements NOT found for cancellation policy.');
      return;
    }
    // Prefer the explicit trigger; fall back to activeElement only if not supplied.
    // On Safari/macOS, pointer activation can leave document.activeElement as <body>,
    // so the caller passes event.currentTarget to guarantee correct focus return.
    modalReturnFocusEl = triggerEl || document.activeElement;
    modal.classList.add('nc-modal-active');
    overlay.classList.add('nc-modal-active');
    document.body.style.overflow = 'hidden';
    const closeBtn = modal.querySelector('.nc-modal-close');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', handleModalKeydown);
  }

  function closeCancellationModal() {
    const modal = document.getElementById('nc-cancellation-modal');
    const overlay = document.getElementById('nc-modal-overlay');
    modal?.classList.remove('nc-modal-active');
    overlay?.classList.remove('nc-modal-active');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', handleModalKeydown);
    if (modalReturnFocusEl && typeof modalReturnFocusEl.focus === 'function') {
      modalReturnFocusEl.focus();
    }
    modalReturnFocusEl = null;
  }

  function createCancellationModal() {
    if (document.getElementById('nc-cancellation-modal')) return;

    const modalHTML = `
      <div id="nc-modal-overlay" class="nc-modal-overlay"></div>
      <div id="nc-cancellation-modal" class="nc-modal" role="dialog" aria-modal="true" aria-labelledby="nc-modal-title">
        <div class="nc-modal-content">
          <button type="button" class="nc-modal-close" aria-label="Close modal">×</button>
          <h3 id="nc-modal-title" class="nc-modal-title">Cancellation Policy</h3>
          <div class="nc-modal-body">
            <p><strong>Subscriptions</strong></p>
            <p>When you purchase a subscription you'll receive repeat deliveries. These are based on the subscription duration and frequency that you select.</p>
            <p>Your payment details will be stored securely and you'll be charged for each of these deliveries, unless you choose to pay in advance.</p>
            <p>Some subscriptions may auto-renew at the end of their duration. If you don't want to renew a subscription you can cancel it.</p>
            <p><strong>If you want to cancel or change your subscription, you can do it at any time. Your order confirmation emails have links to your order. You can manage your subscription from there.</strong></p>
            <p>See our returns policy for more details on returns and refunds.</p>
            </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    const modal = document.getElementById('nc-cancellation-modal');
    const overlay = document.getElementById('nc-modal-overlay');
    const closeButton = modal.querySelector('.nc-modal-close');

    closeButton.addEventListener('click', closeCancellationModal);
    overlay.addEventListener('click', closeCancellationModal);
  }


  // Main script execution on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    console.log('[NC] Script initializing...'); // Keep this one

    // Pricing and variant data (Consider moving to Liquid/Product JSON for maintainability)
    const priceData = {
      '54957490340226': { // 14-day variant ID
        oneTime: { current: '£18.99', compareAt: '£18.99', message: '' },
        subscription: { current: '£16.99', compareAt: '£18.99', message: 'Save £2 every order', sellingPlanId: '710010995074' }
      },
      '54957490372994': { // 28-day variant ID
        oneTime: { current: '£37.98', compareAt: '£37.98', message: '' },
        subscription: { current: '£33.98', compareAt: '£37.98', message: 'Save £4 every order', sellingPlanId: '710029705602' }
      }
    };

    const variantIds = {
      day14: '54957490340226',
      day28: '54957490372994'
    };

    const stackedOptions = [
      {
        id: 'subscription-14',
        variantId: variantIds.day14,
        purchaseType: 'subscription',
        priceKey: 'subscription',
        title: '14 Day Subscription',
        badge: 'Subscribe &amp; Save',
        subtitle: 'Deliver every 14 days (1 box)',
        periodDays: 14,
        displayPrice: { current: '£16.99', compareAt: '£18.99', badge: 'Save £2 every order' },
        highlights: [
          'Pause, skip or cancel any time',
          'Lock in your best price now',
          'Fast &amp; Free UK delivery'
        ],
        footer: ''
      },
      {
        id: 'one-time-14',
        variantId: variantIds.day14,
        purchaseType: 'one-time',
        priceKey: 'oneTime',
        title: '14 Day One-time Purchase',
        badge: '',
        subtitle: '14 sachets (1 box)',
        periodDays: 14,
        displayPrice: { current: '£18.99', compareAt: '£18.99', badge: '' },
        highlights: [
          'Fast &amp; Free UK delivery'

        ],
        footer: ''
      },
      {
        id: 'subscription-28',
        variantId: variantIds.day28,
        purchaseType: 'subscription',
        priceKey: 'subscription',
        title: '28 Day Subscription',
        badge: 'Subscribe &amp; Save',
        subtitle: 'Deliver every 28 days (2 boxes)',
        periodDays: 28,
        displayPrice: { current: '£33.98', compareAt: '£37.98', badge: 'Save £4 every order' },
        highlights: [
          'Pause, skip or cancel any time',
          'Lock in your best price now',
          'Fast &amp; Free UK delivery'
        ],
        footer: ''
      },
      {
        id: 'one-time-28',
        variantId: variantIds.day28,
        purchaseType: 'one-time',
        priceKey: 'oneTime',
        title: '28 Day One-time Purchase',
        badge: '',
        subtitle: '28 sachets (2 boxes)',
        periodDays: 28,
        displayPrice: { current: '£37.98', compareAt: '£37.98', badge: '' },
        highlights: [
          'Fast &amp; Free UK delivery'
        ],
        footer: ''
      }
    ];
    const optionGroups = [
      { id: 'group-14', options: stackedOptions.slice(0, 2) },
      { id: 'group-28', options: stackedOptions.slice(2, 4) }
    ];

    let currentVariantId = stackedOptions[0].variantId;
    let selectedOptionId = stackedOptions[0].id;
    let selectedPurchaseOption = stackedOptions[0].purchaseType;
    let termsTextElement = null;

    function getOptionById(optionId) {
      return stackedOptions.find(option => option.id === optionId);
    }

    function deriveInitialOption(variantId, preferSubscription) {
      const normalizedVariant = priceData[variantId] ? variantId : stackedOptions[0].variantId;
      let option = stackedOptions.find(opt => opt.variantId === normalizedVariant && (!preferSubscription || opt.purchaseType === 'subscription'));
      if (!option) {
        option = stackedOptions.find(opt => opt.variantId === normalizedVariant) || stackedOptions[0];
      }
      return option;
    }

    function buildOptionHTML(option) {
      const isSelected = option.id === selectedOptionId;
      const inputId = `nc-radio-${option.id}`;
      const price = option.displayPrice || priceData[option.variantId]?.[option.priceKey] || {};
      const compareMarkup = price.compareAt && price.compareAt !== price.current
        ? `<span class="nc-compare-price">${price.compareAt}</span>`
        : '';
      const subtitleMarkup = option.subtitle
        ? `<div class="nc-option-subtitle">${option.subtitle}</div>`
        : '';
      const highlightsMarkup = option.highlights?.length
        ? `<ul class="nc-benefits">${option.highlights.map(item => `<li>${item}</li>`).join('')}</ul>`
        : '';
      const footerMarkup = option.footer
        ? `<div class="nc-option-footer">${option.footer}</div>`
        : '';
      const badgeMarkup = option.badge
        ? `<span class="nc-badge">${option.badge}</span>`
        : '';
      const badgeText = price.badge || price.message;
      const savingsMarkup = badgeText
        ? `<span class="nc-savings-pill">${badgeText}</span>`
        : '';
      const dailyPriceText = formatDailyPrice(price.current, option.periodDays);
      const dailyMarkup = dailyPriceText
        ? `<span class="nc-daily-price">${dailyPriceText}</span>`
        : '';
      const detailsMarkup = (highlightsMarkup || footerMarkup)
        ? `<div class="nc-option-details">${highlightsMarkup}${footerMarkup}</div>`
        : '';

      return `
        <div class="nc-stack-option ${isSelected ? 'nc-selected' : ''}" data-option-id="${option.id}" data-variant-id="${option.variantId}" data-purchase-type="${option.purchaseType}">
          <input type="radio" id="${inputId}" class="nc-radio-input" name="${inputId}" value="${option.id}" ${isSelected ? 'checked' : ''} />
          <label for="${inputId}" class="nc-stack-option__hit">
            <span class="nc-radio-visual" aria-hidden="true"></span>
            <div class="nc-option-body">
              <div class="nc-option-header">
                <div class="nc-option-heading-text">
                  <div class="nc-option-title">${option.title} ${badgeMarkup}</div>
                  ${subtitleMarkup}
                  ${detailsMarkup}
                </div>
                <div class="nc-price-column">
                  ${compareMarkup}
                  <span class="nc-current-price">${price.current || ''}</span>
                  ${savingsMarkup}
                  ${dailyMarkup}
                </div>
              </div>
            </div>
          </label>
          <button type="button" class="nc-add-btn" data-option-id="${option.id}">
            <span class="nc-add-label">Add to cart</span>
            <span class="nc-add-price">${price.current || ''}</span>
          </button>
        </div>
      `;
    }

    function renderOptions(container) {
      const groupLegends = {
        'group-14': '14-day delivery options',
        'group-28': '28-day delivery options'
      };
      container.innerHTML = optionGroups.map(group => `
        <fieldset class="nc-option-group nc-fieldset" data-group="${group.id}">
          <legend class="nc-sr-only">${groupLegends[group.id] || 'Subscription options'}</legend>
          ${group.options.map(buildOptionHTML).join('')}
        </fieldset>
      `).join('');
      attachOptionListeners(container);
    }

    function attachOptionListeners(container) {
      const radios = container.querySelectorAll('.nc-radio-input');
      radios.forEach(radio => {
        radio.addEventListener('change', event => {
          if (event.target.checked) handleOptionSelection(event.target.value);
        });
        radio.addEventListener('keydown', handleRadioArrowKeys);
      });
      const addButtons = container.querySelectorAll('.nc-add-btn');
      addButtons.forEach(button => {
        button.addEventListener('click', event => {
          addToCart(event, button.dataset.optionId);
        });
      });
    }

    function handleRadioArrowKeys(event) {
      if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown'
        && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const fieldset = event.currentTarget.closest('fieldset');
      if (!fieldset) return;
      const groupRadios = Array.from(fieldset.querySelectorAll('.nc-radio-input'));
      const currentIndex = groupRadios.indexOf(event.currentTarget);
      if (currentIndex === -1) return;
      event.preventDefault();
      const isForward = event.key === 'ArrowDown' || event.key === 'ArrowRight';
      const nextIndex = isForward
        ? (currentIndex + 1) % groupRadios.length
        : (currentIndex - 1 + groupRadios.length) % groupRadios.length;
      const nextRadio = groupRadios[nextIndex];
      nextRadio.focus();
      handleOptionSelection(nextRadio.value);
    }

    function updateSelectionState() {
      document.querySelectorAll('#nc-custom-purchase-options .nc-stack-option').forEach(optionEl => {
        const isSelected = optionEl.dataset.optionId === selectedOptionId;
        optionEl.classList.toggle('nc-selected', isSelected);
        const input = optionEl.querySelector('.nc-radio-input');
        if (input) input.checked = isSelected;
      });
    }

    function syncVariantInput(variantId) {
      const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
      if (variantInput && variantInput.value !== variantId) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function handleOptionSelection(optionId) {
      const option = getOptionById(optionId);
      if (!option || option.id === selectedOptionId) return;

      selectedOptionId = option.id;
      selectedPurchaseOption = option.purchaseType;
      currentVariantId = option.variantId;

      updateSelectionState();
      syncVariantInput(currentVariantId);
      toggleTermsVisibility();
      updateAddToCartButtonLabels();
    }

    function toggleTermsVisibility() {
      if (!termsTextElement) return;
      termsTextElement.style.display = selectedPurchaseOption === 'subscription' ? 'block' : 'none';
    }

    function getOptionPriceText(option) {
      if (!option) return '';
      const price = option.displayPrice || priceData[option.variantId]?.[option.priceKey] || {};
      return price.current || '';
    }

    function formatDailyPrice(priceText, periodDays) {
      if (!priceText || !periodDays) return '';
      const numeric = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      if (isNaN(numeric)) return '';
      const symbolMatch = priceText.trim().match(/^[^0-9-]+/);
      const symbol = symbolMatch ? symbolMatch[0].trim() : '';
      const dailyValue = numeric / periodDays;
      return `${symbol}${dailyValue.toFixed(2)} per day`;
    }

    function updateAddToCartButtonLabels() {
      document.querySelectorAll('#nc-custom-purchase-options .nc-add-btn').forEach(button => {
        const optionId = button.dataset.optionId;
        const option = getOptionById(optionId);
        if (!option) return;
        const priceText = getOptionPriceText(option);
        const labelEl = button.querySelector('.nc-add-label');
        const priceEl = button.querySelector('.nc-add-price');
        if (labelEl) labelEl.textContent = 'Add to cart';
        if (priceEl) priceEl.textContent = priceText || '';
      });
    }

    /**
     * Replace the default Recharge widget with custom UI.
     */
    function replacePurchaseOptions() {
      const rechargeBlock = document.querySelector('.shopify-block.recharge-subscription-widget');
      if (!rechargeBlock) {
        console.error('[NC] Recharge widget block not found.');
        return;
      }

      const existingCustomUI = document.getElementById('nc-custom-purchase-options');
      if (existingCustomUI) existingCustomUI.remove();

      const urlParams = new URLSearchParams(window.location.search);
      let variantId = urlParams.get('variant');
      const sellingPlanParam = urlParams.get('selling_plan');
      if (!variantId) {
        const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
        if (variantInput) variantId = variantInput.value;
      }

      const initialOption = deriveInitialOption(variantId, Boolean(sellingPlanParam));
      currentVariantId = initialOption.variantId;
      selectedOptionId = initialOption.id;
      selectedPurchaseOption = initialOption.purchaseType;

      const customUI = document.createElement('div');
      customUI.id = 'nc-custom-purchase-options';
      customUI.style.cssText = 'margin-top: 0; margin-bottom: 20px;';

      customUI.innerHTML = `
        <div class="nc-option-stack"></div>
      `;

      rechargeBlock.style.display = 'none';
      rechargeBlock.insertAdjacentElement('afterend', customUI);

      const optionsContainer = customUI.querySelector('.nc-option-stack');
      renderOptions(optionsContainer);
      updateSelectionState();
      syncVariantInput(currentVariantId);
      updateAddToCartButtonLabels();

      let paymentButtonContainer = document.querySelector('.nc-theme-payment-buttons');

      const originalAddToCartBtn = document.querySelector('.featured-product__add-to-cart-button, .product-form__submit');
      if (originalAddToCartBtn) {
        const addToCartContainer = originalAddToCartBtn.closest('.product-form__buttons, .featured-product__add-to-cart-container');
        originalAddToCartBtn.style.display = 'none';
        if (addToCartContainer) {
          addToCartContainer.classList.add('nc-theme-payment-buttons');
          paymentButtonContainer = addToCartContainer;
        }
      }

      if (customUI && paymentButtonContainer && paymentButtonContainer.parentNode) {
        try {
          paymentButtonContainer.parentNode.insertBefore(customUI, paymentButtonContainer);
        } catch (error) {
          console.error('[NC] Error inserting custom UI:', error);
        }
      }
      const mainProductForm = document.querySelector('form[action="/cart/add"]');
      if (mainProductForm) {
        const originalQuantitySelectors = mainProductForm.querySelectorAll('.quantity-selector, .product-form__quantity, .quantity');
        originalQuantitySelectors.forEach(selector => {
          if (selector && !selector.closest('#nc-custom-purchase-options')) {
             const quantityWrapper = selector.closest('.form__input-row, .product-form__input');
             if(quantityWrapper) quantityWrapper.style.display = 'none';
             else selector.style.display = 'none';
          }
        });
        const quantityLabels = mainProductForm.querySelectorAll('label[for*="Quantity"], .quantity__label');
        quantityLabels.forEach(label => {
          if (label && !label.closest('#nc-custom-purchase-options')) label.style.display = 'none';
        });
      }

      const morePaymentOptionsLink = document.querySelector('.shopify-payment-button__more-options');
      if (morePaymentOptionsLink) {
        let termsTextDiv = document.getElementById('nc-subscription-terms');
        if (!termsTextDiv) {
            termsTextDiv = document.createElement('div');
            termsTextDiv.id = 'nc-subscription-terms';
            termsTextDiv.className = 'nc-terms-text';
            termsTextDiv.style.display = 'none';
            termsTextDiv.innerHTML = `This item is a recurring purchase. By continuing, I agree to the <button type="button" class="nc-cancellation-link">cancellation policy</button> and authorize you to charge my payment method at the prices, frequency and dates listed on this page until my order is fulfilled or I cancel, if permitted.`;
            const paymentButtonContainer = morePaymentOptionsLink.closest('.shopify-payment-button');
            try {
              if (paymentButtonContainer?.parentNode) {
                paymentButtonContainer.parentNode.insertBefore(termsTextDiv, paymentButtonContainer.nextSibling);
              } else if (morePaymentOptionsLink.parentNode) {
                morePaymentOptionsLink.parentNode.insertBefore(termsTextDiv, morePaymentOptionsLink.nextSibling);
              }
            } catch (error) {
              console.error('[NC] Error inserting terms text:', error);
            }
        }
        termsTextElement = termsTextDiv;
         const cancellationLink = termsTextDiv.querySelector('.nc-cancellation-link');
         if (cancellationLink) {
             cancellationLink.addEventListener('click', (event) => {
                 event.preventDefault();
                 openCancellationModal(event.currentTarget);
             });
         } else {
             console.error('[NC] Could not find .nc-cancellation-link inside terms text div.');
         }
        toggleTermsVisibility();
      }

      // Ensure modal structure is present
      createCancellationModal();

      console.log('[NC] Custom purchase options initialized.'); // Keep this one
    }

    /**
     * Add product to cart via API.
     * @param {Event} event - The click event.
     */
    function addToCart(event, optionId) {
      event.preventDefault();
      const option = getOptionById(optionId);
      if (!option) {
        console.error('[NC] Unknown option id:', optionId);
        return;
      }
      const variantId = option.variantId;
      const button = event.currentTarget;
      const labelEl = button.querySelector('.nc-add-label');
      const priceEl = button.querySelector('.nc-add-price');

      if (labelEl) labelEl.textContent = 'Adding…';
      if (priceEl) priceEl.textContent = '';
      button.disabled = true;

      const formData = { items: [{ id: variantId, quantity: 1 }] };
      if (option.purchaseType === 'subscription' && priceData[variantId]?.subscription?.sellingPlanId) {
        formData.items[0].selling_plan = priceData[variantId].subscription.sellingPlanId;
      }

      console.log('[NC] Adding to cart:', formData);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then(response => {
          if (!response.ok) {
              return response.json().then(errorData => {
                  throw new Error(errorData?.description || errorData?.message || `HTTP error! status: ${response.status}`);
              });
          }
          return response.json();
      })
      .then(addResponse => {
        if (labelEl) labelEl.textContent = 'Added!';
        setTimeout(() => {
          button.disabled = false;
          updateAddToCartButtonLabels();
        }, 2000);
        getCartAndUpdateUI();
      })
      .catch(error => {
        console.error('[NC] Error adding to cart:', error);
        button.disabled = false;
        updateAddToCartButtonLabels();
        alert(`Error adding product to cart: ${error.message}. Please try again.`);
      });
    }

    /**
     * Fetch cart data, update count display, and trigger theme events/actions.
     */
    function getCartAndUpdateUI() {
        fetch('/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } })
        .then(response => response.json())
        .then(cart => {
            // console.log('[NC] Cart data fetched:', cart);
            updateCartCountDisplay(cart.item_count); // Update count display immediately

            // --- Step 1: Dispatch events BEFORE opening ---
            // This might trigger background updates or update the count correctly
            console.log('[NC] Dispatching initial events (cart:updated, section:load)...');
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: 'cart-drawer' }}));
            document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: 'cart-icon-bubble' }}));

            // --- Step 2: Simulate click to OPEN the drawer ---
            // Use a moderate delay to allow initial events to process if needed
            setTimeout(() => {
                const headerCartIconSelectors = [
                    '.site-header__cart a', '.site-header__cart button', '.header__icon--cart',
                    'a[href="/cart"]', 'button[aria-controls="cart-drawer"]', '#cart-icon-bubble'
                 ];
                 let cartIcon = null;
                 for (const selector of headerCartIconSelectors) {
                    cartIcon = document.querySelector(selector);
                    if (cartIcon) break;
                 }
                if (cartIcon) {
                    console.log('[NC] Simulating click on header cart icon.');
                    cartIcon.click(); // Open the drawer

                    // --- Step 3: Dispatch events AGAIN AFTER opening ---
                    // Give the drawer animation a moment, then force update
                    setTimeout(() => {
                         console.log('[NC] Re-dispatching events after drawer open attempt...');
                         // Re-dispatch with the same cart data, hoping the theme redraws the visible drawer
                         document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
                         document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: 'cart-drawer' }}));
                    }, 300); // Delay after click (adjust if needed, e.g., 200-500ms)

                } else {
                    console.warn('[NC] Could not find header cart icon element to simulate click.');
                }
            }, 250); // Delay before click (was 500/750, maybe shorten slightly?)

        })
        .catch(error => {
            console.error('[NC] Error getting cart:', error);
        });
    }

    /**
     * Update displayed selection when the variant input changes (e.g., theme scripts).
     */
    function updatePriceDisplay() {
      const variantInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
      if (!variantInput) { console.warn('[NC] Variant input not found'); return; }
      const newVariantId = variantInput.value;
      if (!newVariantId || !priceData[newVariantId]) { console.warn('[NC] Invalid variant ID:', newVariantId); return; }

      if (currentVariantId !== newVariantId) {
        currentVariantId = newVariantId;
        const matchingOption = stackedOptions.find(opt => opt.variantId === newVariantId && opt.purchaseType === selectedPurchaseOption)
          || stackedOptions.find(opt => opt.variantId === newVariantId);
        if (matchingOption) {
          selectedOptionId = matchingOption.id;
          selectedPurchaseOption = matchingOption.purchaseType;
          updateSelectionState();
          toggleTermsVisibility();
          updateAddToCartButtonLabels();
        }
      }
    }

    // --- Initialization ---
    requestAnimationFrame(() => { // Wait for next frame to likely avoid layout shifts
        replacePurchaseOptions();
    });

    // --- Variant Change Listeners ---
    const productForm = document.querySelector('form[action="/cart/add"]');
    if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) {
            // Use MutationObserver for reliable variant input change detection
            const observer = new MutationObserver((mutationsList) => {
                for(let mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                        setTimeout(updatePriceDisplay, 50); // Short delay for other scripts
                        break;
                    }
                }
            });
            observer.observe(variantInput, { attributes: true });
        } else {
             console.warn('[NC] Could not find variant input for MutationObserver setup. Using fallback.');
             // Fallback: Listen for changes on radio/select inputs
             document.addEventListener('change', event => {
                if (event.target.matches('input[type="radio"][name^="option"], select[name="id"]')) {
                    setTimeout(updatePriceDisplay, 100);
                }
             });
        }
    } else {
        console.warn('[NC] Could not find product form. Using fallback variant change listener.');
         document.addEventListener('change', event => {
            if (event.target.matches('input[type="radio"][name^="option"], select[name="id"]')) {
                setTimeout(updatePriceDisplay, 100);
            }
         });
    }
    // Support for BOLD app events (if applicable)
    if (typeof window.BOLD?.common?.eventEmitter?.on === 'function') {
      window.BOLD.common.eventEmitter.on('BOLD_COMMON_variant_changed', () => {
         console.log('[NC] BOLD variant changed event detected'); // Keep this for integration check
        setTimeout(updatePriceDisplay, 100);
      });
    }

  });
